import { SignUp } from "@clerk/clerk-react";
import { createFileRoute, Link } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { AuthSceneLayout } from "@/components/auth/AuthSceneLayout";
import { clerkAuthAppearance } from "@/components/auth/clerkAppearance";

export const Route = createFileRoute("/_public/sign-up/$")({
	validateSearch: (
		search: Record<string, unknown>,
	): { redirectTo?: string } => ({
		redirectTo:
			typeof search.redirectTo === "string" && search.redirectTo.length > 0
				? search.redirectTo
				: undefined,
	}),
	component: SignUpPage,
});

function SignUpPage() {
	const { t } = useTranslation();
	const { redirectTo } = Route.useSearch();
	const forceRedirectUrl = redirectTo;
	const signInUrl = redirectTo
		? `/sign-in?redirectTo=${encodeURIComponent(redirectTo)}`
		: "/sign-in";

	return (
		<AuthSceneLayout
			footer={
				<p className="text-sm text-base-content/70">
					{t("common.alreadyHaveAccount")}{" "}
					<Link to={signInUrl} className="link link-primary font-medium">
						{t("common.signIn")}
					</Link>
				</p>
			}
		>
			<SignUp
				routing="path"
				path="/sign-up"
				appearance={clerkAuthAppearance}
				// sign_up (GA4) fires from SignUpAnalytics on completed cadastro
				// (SignUp complete / createdSessionId, or first signed-in hop
				// after a /sign-up attempt). Mounting this page must not emit.
				fallbackRedirectUrl="/app/select-organization"
				forceRedirectUrl={forceRedirectUrl}
				// Ensure switching to sign-in inside Clerk UI also preserves redirectTo
				signInUrl={signInUrl}
			/>
		</AuthSceneLayout>
	);
}
